/**
 * Google Analytics Service
 */
declare let gtag: Function;

/**
 * Google Analytics Service
 */
export class GoogleAnalyticsService {

  public sendEvent(category: string, action: string, label: string, value: number = 10): void {
    //console.log(category, action, label, value);
    gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
    //console.log(gtag);
  }
}